<template>
  <div>
    <div class="back-btn-container">
      <back-btn />
      <h3 class="title-page">{{ $tc("orderHistory") }}</h3>
    </div>
    <div class="mdm-table">
      <div class="admin_container">
        <div class="d-flex justify-space-between mb-3">
          <v-btn
            color="primary"
            v-if="histories.length"
            :to="{
              name: 'order-history-item',
              query: { numb: $route.query.numb },
            }"
          >
            {{ $tc("orderHistory", 0) }}
          </v-btn>
        </div>
        <table-with-filter
          fixed-header
          :height="$vuetify.breakpoint.height - 205"
          :headers="headers"
          :items="histories"
        >
          <template #filter.numb>
            <div class="pa-1">
              <custom-input-text
                @input="getHistoryWithFilter"
                v-model="historyFilter.numb"
                clearable
                class="user_input no-margin"
              />
            </div>
          </template>
          <template #filter.state>
            <div class="pa-1">
              <custom-select
                @input="getHistoryWithFilter"
                :items="orderStatus"
                item-text="text"
                item-value="value"
                v-model="historyFilter.state"
                clearable
                class="user_input no-margin"
              />
            </div>
          </template>
          <template #filter.sendDate>
            <div class="pa-1 d-flex align-center">
              <custom-date-picker
                clearable
                :max="historyFilter.toDate || new Date()"
                @input="getHistoryWithFilter"
                v-model="historyFilter.fromDate"
                hide-details
                color="#E3EBF3"
                class="mr-1 ml-1 data_item data_item_calendar user_input"
                icon="mdi-calendar-month small"
              ></custom-date-picker>
              <span class="text--accent-1 blue-dark--text">
                {{ $t("to") }}</span
              >
              <custom-date-picker
                hide-details
                :start-day="false"
                :min="historyFilter.fromDate"
                :max="new Date()"
                @input="getHistoryWithFilter"
                v-model="historyFilter.toDate"
                clearable
                color="#E3EBF3"
                class="data_input_tw ml-2 data_item user_input"
                icon="mdi-calendar-month small"
              ></custom-date-picker>
            </div>
          </template>
          <template #item.state="{ item }">
            <div :class="{ 'notify-text': item.changes.indexOf('state') > -1 }">
              <span class="notify-text-element">{{ $t(item.state) }}</span>
            </div>
          </template>
          <template #item.updatedDate="{ item }">{{
            item.updatedDate | fullTimeParse
          }}</template>
          <template #item.action="{ item, index }">
            <v-btn
              v-if="index !== 0 && $can($permissions['RESTORE'])"
              class="new_style"
              @click="onRestore(index)"
            >
              <vue-icon icon="newTimeIcon"></vue-icon>
            </v-btn>
          </template>
        </table-with-filter>
        <warning-dialog
          @apply="PrevChangeOrder"
          @cancel="selectedHistoryIndex = null"
          v-model="warningDialog"
          description="doYouWantGoBack"
          yes-text="yes"
        ></warning-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { debounce, getQueryByKey } from "@/utils/pureFunctions";
import BackBtn from "@/components/ui/BackBtn";
import TableWithFilter from "@/components/ui/table/TableWithFilter";
import { orderStatus } from "@/utils/constants";
import WarningDialog from "@/components/ui/prompt/warning-dialog";

export default {
  name: "history-order",
  data() {
    return {
      selectedHistoryIndex: null,
      warningDialog: false,
      isShowFilter: false,
      historyFilter: {
        numb: null,
        fromDate: null,
        toDate: null,
        state: null,
      },
      histories: [],
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("requestNumber"),
          value: "numb",
        },
        {
          text: this.$t("updatedDate"),
          value: "updatedDate",
        },
        {
          text: this.$t("status"),
          value: "state",
        },
        {
          text: this.$t("updatedByUser"),
          value: "statusChangedUser",
        },
        {
          text: this.$t("action"),
          value: "action",
        },
      ];
    },
    orderStatus() {
      return Object.keys(orderStatus).map((item) => {
        return {
          text: this.$t(item),
          value: item,
        };
      });
    },
  },
  methods: {
    onRestore(index) {
      this.selectedHistoryIndex = index;
      this.warningDialog = true;
    },
    async PrevChangeOrder() {
      this.showLoading();
      try {
        await this.$http.post("backend/previous-changes-order", {
          objectId: this.histories[this.selectedHistoryIndex].id,
          revision: this.histories[this.selectedHistoryIndex].revision,
        });
        await this.getHistories();
      } catch (err) {
        this.setResponseError({ error: err });
      } finally {
        this.clearLoading();
      }
    },
    changePage(page) {
      this.$router.replace({ query: { page: `${page}` } });
      this.getHistoryWithLoading();
    },
    getHistoryWithFilter: debounce(function () {
      const query = this.historyFilter;
      this.$router.replace({ query }).catch(() => {});
      this.getHistoryWithLoading();
    }, 300),

    async getHistories() {
      const params = { ...this.historyFilter };
      try {
        const {
          data: { data },
        } = await this.$http.get("history/orders", {
          params,
        });
        this.histories = [...data];
      } catch (e) {
        this.setResponseError({ error: e });
      }
    },
    async getHistoryWithLoading() {
      this.showLoading();
      await this.getHistories();
      this.clearLoading();
    },
  },
  components: {
    WarningDialog,
    TableWithFilter,
    BackBtn,
  },
  async created() {
    this.historyFilter = getQueryByKey(this.historyFilter, this.$route.query);
    this.showLoading();
    await this.getHistories();
    this.clearLoading();
  },
};
</script>
